import { AuthActionTypes, AuthActions } from './auth.actions';
import { Login, User } from './auth.model';

export interface AuthState {
  isAuthenticated :boolean;
  user :User | null;
  login :Login | null;
  errorMessage :string | null;
  isUserLoaded :boolean | false;
}

export const initialAuthState :AuthState = {
  isAuthenticated: false,
  user: null,
  login: null,
  errorMessage: null,
  isUserLoaded: false,
};

export function authReducer(
  state = initialAuthState,
  action :AuthActions,
) :AuthState {
  switch (action.type) {
    case AuthActionTypes.LOGIN: {
      return {
        ...state,
        isAuthenticated: true,
      };
    }

    case AuthActionTypes.LOGIN_SUCCESS: {
      const _login :Login = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        login: _login,
      };
    }

    case AuthActionTypes.USER_LOADED: {
      const _user :User = action.payload;

      return {
        ...state,
        isAuthenticated: true,
        user: _user,
        isUserLoaded: true,
      };
    }

    case AuthActionTypes.LOGOUT: {
      return initialAuthState;
    }

    default: {
      return state;
    }
  }
}
